module.exports = __webpack_public_path__ + "img/logo.3a1968c7.png";